<template>
    <div id="app" dark style="padding: 0px !important;">

<!--
        <img id="full-screen-background-image" src="../assets/01.jpg" style="padding: 0px !important;">
-->

        <div id="overlay"></div>

        <v-container style="padding: 0px !important;max-width: 750px">

            <v-layout row wrap style="padding: 0px !important;">

                <v-flex xs12 sm8 offset-sm2 align-center justify-center>

                    <v-card class="text-xs-center transparent" flat style="margin:auto;margin-top: 35%;max-width: 600px;padding: 0px !important;">

                        <v-card-text style="padding: 4px !important;">

                            <v-toolbar flat class="transparent">
                                <h2 class="white--text">RECOVERY ACCESS</h2>
                            </v-toolbar>

                            <v-container>

                                <v-progress-linear v-if="loading" v-bind:indeterminate="true" height="2" color="primary"></v-progress-linear>

                                <v-alert class="text-xs-left" flat color="error" icon="warning" :value="error">
                                    {{ message }}
                                </v-alert>

                                <v-alert class="text-xs-left" flat color="success" icon="check_circle" :value="success">
                                    {{ message }}
                                </v-alert>

                                <v-form v-if="success" v-model="valid" ref="form" lazy-validation v-on:submit.prevent="go">

                                    <v-progress-linear v-if="loading" v-bind:indeterminate="true" height="2" color="primary"></v-progress-linear>

                                    <v-alert class="text-xs-left" flat color="error" icon="warning" :value="error">
                                        {{ message }}
                                    </v-alert>

                                    <v-alert class="text-xs-left" flat color="success" icon="check_circle"  :value="success">
                                        {{ message }}
                                    </v-alert>

                                    <h2 class="text-xs-left" style="color: white" v-if="!error">Olá {{name}}</h2>

                                    <v-layout row>
                                        <v-text-field light
                                                      label="Digite uma senha"
                                                      type="password"
                                                      v-model="password"
                                                      :rules="Rules"
                                                      required
                                        ></v-text-field>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs12>
                                            <v-text-field light
                                                          label="Repita a senha acima"
                                                          type="password"
                                                          v-model="confirm_password"
                                                          :rules="Rules"
                                                          required
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex xs12 md12 sm12>
                                            <v-btn v-if="!success" type="submit" :disabled="!valid" dark flat class="blue darken-4">
                                                Salvar
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>

                                <v-flex xs12 md12 sm12>
                                    <v-btn v-if="!success"  @click="backToLogin" dark flat class="black darken-4">
                                        Tentar novamente
                                    </v-btn>
                                </v-flex>

                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<style>
    .v-input__control {
        background-color: transparent !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
        -webkit-transition-delay: 9999s;
    }

    body, html{
        overflow: auto !important;
    }
    #full-screen-background-image {
        min-height: 100%;
        min-width: 1024px;
        width: 100%;
        height: auto;
        position: fixed;
        top: 0;
        left: 0;
    }
    #overlay {
        position: fixed; /* Sit on top of the page content */
        display: block; /* Hidden by default */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.67); /* Black background with opacity */
        z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    }
</style>
<script>
    export default {
        name: 'recovery',
        data: function () {
            return {
                show: false,
                name:'',
                snackbar: true,
                loading: false,
                password: '',
                confirm_password: '',
                token: '',
                success: false,
                error: false,
                message: '',
                valid: false,
                Rules: [
                    (v) => !!v || 'Este campo é obrigatório'
                ]
            }
        },
        methods: {
            backToLogin: function () {
                this.$router.push('/auth')
            },
            goRecovery: function () {
                this.setForm = false
                this.success = false
                this.error = false
            },
            go: function () {
                var self = this
                if (this.$refs.form.validate()) {
                    this.message = ''
                    this.success = false
                    this.error = false
                    this.loading = true
                    this.axios.post('/save-password.json', {token: this.token, confirm_password: this.confirm_password, password: this.password}, {headers: {'Authorization': ''}}).then((response) => {
                        this.loading = false
                        if (response.data.success === true) {
                            this.success = true
                            this.message = response.data.messages
                            setTimeout(function () {
                                self.$router.push('/')
                            }, 6000)
                        } else {
                            this.error = true
                            this.message = response.data.messages
                        }
                    })
                }
            },
            recovery: function () {
                this.success = false
                this.error = false
                this.message = ''
                this.loading = true
                if (this.$refs.form2.validate()) {
                    this.axios.post('/recovery-password.json', {email: this.email, password: this.password}, {headers: {'Authorization': ''}}).then((response) => {
                        this.loading = false
                        if (response.data.success === true) {
                            this.success = true
                            this.message = response.data.messages
                        } else {
                            this.error = true
                            this.message = response.data.messages
                        }
                    })
                }
            }
        },
        created:function () {
            this.error = false
            if(this.$store.getters.isAuthenticated==false){
                this.show = true
            }
            let uri = window.location.search.substring(1)
            let params = new URLSearchParams(uri)
            this.token = params.get('token')
            this.axios.post('/recovery.json', {token: this.token}, {headers: {'Authorization': ''}}).then((response) => {
                if (response.data.success === true) {
                    this.name = response.data.name
                }else{
                    this.error = true
                    this.message = response.data.messages
                }
            })
        }
    }
</script>
